import { c as _c } from "react/compiler-runtime";
import Link from '@precis-digital/kurama/Link';
import Grid from '@precis-digital/kurama/Grid';
import Tooltip from '@precis-digital/kurama/Tooltip';
import Typography from '@precis-digital/kurama/Typography';
import { type ReactElement, type ReactNode } from 'react';
import OverScreen from 'shared/overScreens/niceModalReact';
import { useTranslation } from 'shared/translations';
import { type Member } from 'src/workspace/api';
const AssigneeTooltip = t0 => {
  const $ = _c(16);
  const {
    assigneeMember,
    shouldOpenProfileFlyout: t1,
    children
  } = t0;
  const shouldOpenProfileFlyout = t1 === undefined ? true : t1;
  const {
    t
  } = useTranslation("recommendation");
  let t2;
  if ($[0] !== assigneeMember?.id) {
    t2 = e => {
      e.stopPropagation();
      e.preventDefault();
      OverScreen.show("profileFlyout", {
        id: assigneeMember?.id
      });
    };
    $[0] = assigneeMember?.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleLinkClick = t2;
  let t3;
  if ($[2] !== assigneeMember?.name || $[3] !== handleLinkClick || $[4] !== shouldOpenProfileFlyout || $[5] !== t) {
    t3 = () => {
      if (shouldOpenProfileFlyout) {
        return <Grid display="flex" gap="4px"><Typography variant="body2">{t("assigneeTooltip")}</Typography><Link variant="body2" onClick={handleLinkClick}>{assigneeMember?.name}</Link></Grid>;
      }
      return <Grid display="flex" gap="4px"><Typography variant="body2">{t("assigneeTooltip")}</Typography><Typography variant="body2">{assigneeMember?.name}</Typography></Grid>;
    };
    $[2] = assigneeMember?.name;
    $[3] = handleLinkClick;
    $[4] = shouldOpenProfileFlyout;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderAssigneeName = t3;
  let t4;
  if ($[7] !== assigneeMember?.name || $[8] !== renderAssigneeName || $[9] !== t) {
    t4 = <Grid container={true} flexDirection="column"><Grid display="inline-flex" gap="4px">{assigneeMember?.name != null ? renderAssigneeName() : <Typography variant="body2">{t("unAssigneeTooltip")}</Typography>}</Grid></Grid>;
    $[7] = assigneeMember?.name;
    $[8] = renderAssigneeName;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children) {
    t5 = <Grid>{children}</Grid>;
    $[11] = children;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Tooltip title={t4} kind="singleline">{t5}</Tooltip>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default AssigneeTooltip;